import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core'
import { AppointmentModel, PatientDataService } from '@mmx/shared'
import { BehaviorSubject, filter, map, switchMap } from 'rxjs'

@Component({
  selector: 'mmx-appointment-portal-menu',
  templateUrl: './appointment-portal-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppointmentPortalMenuComponent implements OnChanges {
  @Input()
  public appointment: AppointmentModel

  private changes$ = new BehaviorSubject<SimpleChanges>(null)

  public authRules$ = this.changes$
    .pipe(
      filter(() => !!this.appointment?.authRules),
      switchMap(() => this.patientDataService.insurances$),
      map((insurances) => {
        return this.appointment.authRules
          .map((authRule) => {
            const insurance = insurances.find(({ lookup }) => authRule.carrierLookups.some((lu) => lu.id === lookup?.id))

            return insurance && {
              ...authRule,
              insurance,
            }
          })
          .filter(Boolean)
      }),
    )

  constructor(
    private patientDataService: PatientDataService,
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    this.changes$.next(changes)
  }
}
